import { footerData } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-background-900 text-white">
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 opacity-[0.03]">
          <svg viewBox="0 0 1440 600" className="w-full h-full" preserveAspectRatio="none">
            <path d="M0,300 Q360,150 720,300 T1440,300" fill="none" stroke="white" strokeWidth="0.5" />
            <path d="M0,400 Q360,250 720,400 T1440,400" fill="none" stroke="white" strokeWidth="0.5" />
            <circle cx="720" cy="300" r="250" fill="none" stroke="white" strokeWidth="0.3" />
            <circle cx="720" cy="300" r="180" fill="none" stroke="white" strokeWidth="0.3" />
          </svg>
        </div>

        <div className="relative z-10 max-w-[1280px] mx-auto px-4 md:px-6 lg:px-10 pt-14 md:pt-20 pb-8">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 mb-12 md:mb-16">
            <div className="lg:w-[380px] flex-shrink-0">
              <div className="flex items-center gap-2 mb-5">
                <div className="w-7 h-7 md:w-8 md:h-8 rounded-full bg-primary-500 flex items-center justify-center">
                  <i className="ri-fire-line text-white text-sm"></i>
                </div>
                <span className="text-white font-heading font-bold text-lg md:text-xl">
                  51吃瓜爆料网
                  <span className="text-accent-400 ml-1">.</span>
                </span>
              </div>
              <p className="text-white/50 text-sm leading-relaxed mb-6">
                {footerData.description}
              </p>

              <div className="flex items-center gap-2 mb-6">
                <div className="flex-1 relative">
                  <input
                    type="email"
                    placeholder="输入邮箱订阅最新爆料"
                    className="w-full bg-transparent border border-white/20 rounded-full px-4 py-2.5 text-sm text-white placeholder:text-white/30 outline-none focus:border-white/40 transition-colors"
                  />
                </div>
                <button className="w-10 h-10 rounded-full bg-primary-500 hover:bg-primary-600 flex items-center justify-center cursor-pointer transition-colors flex-shrink-0" aria-label="订阅">
                  <i className="ri-notification-3-line text-white"></i>
                </button>
              </div>

              <p className="text-white font-heading font-bold text-xl md:text-2xl leading-snug">
                {footerData.tagline}
              </p>
              <p className="text-white/50 font-heading text-base md:text-lg mt-1">
                {footerData.tagline2}
              </p>
            </div>

            <div className="flex-1 grid grid-cols-2 sm:grid-cols-4 gap-6 md:gap-8">
              {footerData.cols.map((col, idx) => (
                <div key={idx}>
                  <h4 className="text-white font-semibold text-sm mb-4">{col.title}</h4>
                  <ul className="space-y-2.5">
                    {col.links.map((link, linkIdx) => (
                      <li key={linkIdx}>
                        <a
                          href={link.href}
                          className="text-white/45 hover:text-white/70 text-sm transition-colors"
                        >
                          {link.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-white/30 text-xs">
              &copy; {new Date().getFullYear()} 51吃瓜爆料网. All rights reserved.
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 rounded-lg border border-white/15 flex items-center justify-center cursor-pointer text-white/40 hover:text-white/70 hover:border-white/30 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-lg border border-white/15 flex items-center justify-center cursor-pointer text-white/40 hover:text-white/70 hover:border-white/30 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-lg border border-white/15 flex items-center justify-center cursor-pointer text-white/40 hover:text-white/70 hover:border-white/30 transition-colors" aria-label="抖音">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-lg border border-white/15 flex items-center justify-center cursor-pointer text-white/40 hover:text-white/70 hover:border-white/30 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
            <a href="#" className="text-white/30 hover:text-white/50 text-xs transition-colors">
              隐私政策
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}